import { render, staticRenderFns } from "./sliderTarget.vue?vue&type=template&id=642c5f4b&scoped=true&lang=pug"
import script from "./sliderTarget.vue?vue&type=script&lang=js"
export * from "./sliderTarget.vue?vue&type=script&lang=js"
import style0 from "./sliderTarget.vue?vue&type=style&index=0&id=642c5f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c5f4b",
  null
  
)

export default component.exports